export default __webpack_public_path__ + "static/media/approve_challenges.f979674d.svg";